import { ReactElement } from 'react'
import { FollowUpCard } from './FollowUpCard'
import { FormCard } from './FormCard'
import { ImportCard } from './ImportCard'
import { InboundCallCard } from './InboundCallCard'
import { OutboundCallCard } from './OutboundCallCard'
import { SchedulerCard } from './SchedulerCard'
import { ContactCard } from 'app/components/shared/ContactCard'
import type { ActivityJson } from 'app/types/entities'
import type { LocationJson } from 'app/types/entities'

type Props = {
  activity?: ActivityJson
  location?: LocationJson
  onChange?: (id: string) => void
  onContactClick?: (contactId: string) => void
}
export function ActivityInfo({ activity, location, onChange, onContactClick }: Props): ReactElement | null {
  const isIntegrated = !!location?.sikkaOfficeId

  const getActivityCard = (activity: ActivityJson) => {
    switch (activity.type) {
      case `FollowUp`:
        return (
          <FollowUpCard
            activity={activity}
            contact={activity.contacts?.[0]}
            onChange={onChange}
            alwaysOpen
            singleActivity
          />
        )
      case `Form`:
        return <FormCard activity={activity} alwaysOpen singleActivity />
      case `Call`:
        return activity.subType === `outbound` ? (
          <OutboundCallCard
            activity={activity}
            contact={activity.contacts?.[0]}
            onActivityUpdated={(activity) => activity && onChange?.(activity.id!)}
            singleActivity
          />
        ) : (
          <InboundCallCard
            activity={activity}
            contact={activity.contacts?.[0]}
            onActivityUpdated={(activity) => activity && onChange?.(activity.id!)}
            alwaysOpen
            singleActivity
          />
        )
      case `Chat`:
      case `Imported Form`:
      case `Online Scheduler`:
      case `Virtual Consultation`:
        return <ImportCard activity={activity} alwaysOpen singleActivity />
      case `Scheduler`:
        return <SchedulerCard activity={activity} alwaysOpen singleActivity />
      default:
        return <></>
    }
  }

  return (
    <div className="flex h-full grow flex-col overflow-y-auto bg-surface-subtle pb-2">
      {activity && <div className="my-4 bg-surface">{getActivityCard(activity)}</div>}
      {!!activity?.contacts?.length && <hr className="border-t border-default" />}
      {activity?.contacts?.map((contact) => (
        <ContactCard
          key={contact.id}
          activityContact={contact}
          isIntegrated={isIntegrated}
          onContactClick={onContactClick}
        />
      ))}
    </div>
  )
}
